// utils/serviceMatcher.js
import { remove as removeDiacritics } from 'diacritics'; // Use 'diacritics' package

export const serviceKeywords = {
  whatsappResponder: [
    'whatsapp',
    'chat automático',
    'chatbot',
    'respuestas automáticas',
    'mensaje automático',
    'respuesta inmediata',
    'soporte digital',
    'soporte 24 horas',
    'asistente virtual',
    'atención automatizada',
    'automatización de chat',
    'ayuda instantánea',
    'respuesta programada',
    'inteligencia artificial'
  ],

  campaignAssistant: [
    'publicidad',
    'promoción digital',
    'campañas en redes',
    'anuncios pagados',
    'facebook ads',
    'instagram ads',
    'difusión digital',
    'post promocional',
    'estrategia de ventas',
    'segmentación de clientes',
    'visibilidad online',
    'contenido promocional',
    'publicidad automatizada'
  ],

  digitalCatalog: [
    'catálogo digital',
    'galería de productos',
    'inventario en línea',
    'lista de precios',
    'colección visual',
    'presentación online',
    'mostrador virtual',
    'mostrador digital',
    'menú digital',
    'servicios disponibles',
    'mostrar catálogo',
    'ver productos'
  ],

  orderForm: [
    'pedidos en línea',
    'formulario de pedido',
    'ordenar en línea',
    'pedido rápido',
    'carrito de compras',
    'solicitud de producto',
    'checkout digital',
    'compra directa',
    'canasta de productos',
    'enviar orden',
    'orden de compra'
  ],

  onlinePayments: [
    'cobros en línea',
    'pagos en línea',
    'cobros digitales',
    'pasarela de pagos',
    'aceptar tarjetas',
    'link de pago',
    'transferencia electrónica',
    'pago con tarjeta',
    'cobro con tarjeta',
    'enlace de cobro',
    'finanzas digitales',
    'método de pago'
  ],

  crmLite: [
    'crm lite',
    'gestión de clientes',
    'seguimiento de ventas',
    'registro de contactos',
    'historial de conversación',
    'anotar mensajes',
    'perfil de cliente',
    'estado del cliente',
    'organizar datos',
    'panel de control',
    'resumen visual'
  ],

  qrFlyers: [
    'volantes qr',
    'volantes con qr',
    'folletos digitales',
    'código escaneable',
    'código qr',
    'material promocional impreso',
    'promoción física',
    'impresión con código',
    'diseño con qr',
    'papelería promocional',
    'campaña con qr'
  ]
};

export function matchServicesFromAI(text) {
  const normalizedText = removeDiacritics(text.toLowerCase());

  // This ensures 'whatsappResponder' is always present and unique
  const matchedSet = new Set(['whatsappResponder']);

  for (const [id, keywords] of Object.entries(serviceKeywords)) {
    for (const keyword of keywords) {
      const normalizedKeyword = removeDiacritics(keyword.toLowerCase());

      // Use a word boundary regex to match full words
      const pattern = new RegExp(`\\b${normalizedKeyword}\\b`, 'i');

      if (pattern.test(normalizedText)) {
        matchedSet.add(id);
        break; // Avoid duplicates
      }
    }
  }

  return Array.from(matchedSet);
}